import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getQATeam } from 'models/qateam'; // Importing getQATeam model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a data view extending JetView.
 */
export default class dataView extends JetView {
    /**
     * Configures the layout and components of the data view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        this.minItemWidth = 243; // Minimum width for items in the view
        const initCount = Math.floor(
            document.documentElement.clientWidth / this.minItemWidth, // Calculate initial item count based on viewport width
        );
        const _ = this.app.getService('locale')._; // Localization service
        const vthis = this; // Reference to the current instance

        // Event listener for date changes in the dashboard
        this.on(this.app, 'dateDashboard:date', (date) => {
            var dateRange = date; // Store the date range from the event
            $$('b1').setValue('Dashboard ' + dateRange.day); // Update the dashboard title with the selected date

            // AJAX request to fetch data for the selected date
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'Dashboard/GetDateView', // API endpoint for fetching data
                    dateRange, // Data to send in the request
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Display error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text); // Parse the response data
                            data.forEach(function (obj) {
                                obj.name = _(obj.name); // Localize the name property of each object
                            });
                            vthis.$$('dataview').clearAll(); // Clear existing data in the dataview
                            vthis.$$('dataview').parse(data); // Parse and display the new data in the dataview
                        },
                    },
                );
        });

        // Return the layout configuration for the view
        return {
            type: 'wide', // Set the type of the layout
            rows: [
                {
                    view: 'text', // Text component for the dashboard title
                    id: 'b1', // Unique identifier for the component
                    value: 'Dashboard', // Initial value of the text component
                    disabled: true, // Disable editing of the text
                    css: 'dashboard-stats', // CSS class for styling
                },
                {
                    view: 'dataview', // Dataview component for displaying data
                    localId: 'dataview', // Local identifier for the dataview
                    // Determine the number of items to display based on initial count
                    xCount: initCount > 4 ? 3 : initCount >= 0 && initCount <= 2 ? 1 : initCount - 2,
                    scroll: false, // Disable scrolling
                    height: 50, // Set height of the dataview
                    type: {
                        width: 'auto', // Set width to auto
                        type: 'wide', // Set type to wide
                        css: 'dashboard-stats', // CSS class for styling
                        template: (obj, common) => {
                            // Template function for rendering each item
                            return (
                                " <span style='font-weight:bold;display:inline-block' class='" +
                                _(obj.icon) +
                                "' ></span>" +
                                "<span class='dash-title' style='font-size:20px;font-weight:bold;padding:12px;display:inline-block'>" +
                                _(obj.name) +
                                ':' +
                                '</span>' +
                                "<span class='dash-result' style='font-size:20px;padding:12px;display:inline-block'>" +
                                _(obj.value) +
                                '</span>'
                            );
                        },
                    },
                },
            ],
        };
    }

    /**
     * Initializes the data view.
     */
    init() {}
}

// FILE DOCUMENTED
